import React from 'react';
import * as dates from 'date-arithmetic';
import { Navigate } from 'react-big-calendar';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';
import { withTranslation } from 'react-i18next';
import hoistStatics from 'hoist-non-react-statics';
import moment from 'moment';

class CalendarWeekView extends React.Component {
	render() {
		const { date, startOfWeek, events } = this.props;
		const range = CalendarWeekView.range(date, startOfWeek, events);
		return <TimeGrid {...this.props} range={range} eventOffset={15} />;
	}
}

CalendarWeekView.range = (date, startOfWeek, lessons) => {
	let firstDayOfWeek = moment(date).startOf('isoWeek');
	if (startOfWeek) {
		const currentWeekday = moment(date).isoWeekday();
		startOfWeek = currentWeekday < startOfWeek ? startOfWeek - 7 : startOfWeek;
		firstDayOfWeek = moment(date).isoWeekday(startOfWeek);
	}

	let start = firstDayOfWeek.startOf('day').toDate();
	let end = firstDayOfWeek.add(6, 'day').endOf('day').toDate();
	let current = start;
	let range = [];

	let days = lessons.filter(lesson => lesson.start >= start && lesson.start < end)
						.map(lesson => moment(lesson.start).format('LL'));

	while (dates.lte(current, end, 'day')) {
		//if no classes in week show empty calendar with all days
		if (days.length === 0 || days.indexOf(moment(current).format('LL')) > -1) {
			range.push(current);
		}
		current = dates.add(current, 1, 'day');
	}

	return range;
};

CalendarWeekView.navigate = (date, action) => {
	switch (action) {
		case Navigate.PREVIOUS:
			return dates.add(date, -1, 'week');
		case Navigate.NEXT:
			return dates.add(date, 1, 'week');
		default:
			return date;
	}
};

CalendarWeekView.title = () => {
	return '';
};

// react-i18next v8's withNamespaces hoisted non-React statics onto the wrapper; v15's
// withTranslation does not. react-big-calendar reads range/navigate/title off whatever
// component it is handed, so they must be copied across or Calendar throws
// "View.title is not a function".
export default hoistStatics(withTranslation()(CalendarWeekView), CalendarWeekView);